<div class="g-ui-grid-page__title">
  <app-heading level="h1" [text]="texts.settings.data_collection.data_sources.title"></app-heading>
</div>
<app-tabs [tabConfig]="tabConfig" [tabs]="tabs"></app-tabs>
<ng-template #sensors>
  <app-sensors></app-sensors>
</ng-template>
<ng-template #otAgents>
    <app-ot-agents></app-ot-agents>
</ng-template>
<ng-template #iotConnectors>
  <app-iot-connectors></app-iot-connectors>
</ng-template>
<ng-template #pcap>
  <app-pcap-player></app-pcap-player>
</ng-template>
<ng-template #uploads>
  <app-cards-page>
    <ng-container appCardPageContent>
      <app-update-assets-csv></app-update-assets-csv>
      <app-upload-assets></app-upload-assets>
      <app-scd-files></app-scd-files>
      <app-otd-scan-file-upload></app-otd-scan-file-upload>
      <app-project-files></app-project-files>
    </ng-container>
  </app-cards-page>
</ng-template>
